import { styled, css } from 'styled-components';

export const HeadingTxt = css`
  font-family: var(--main-font);
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0.6px;
  color: #242527;
  margin-top: 0;
  margin-bottom: 0;
  white-space: pre-line;
`;

export const Heading = styled.h3`
  ${HeadingTxt}
  text-transform: uppercase;
`;

export const CenteredHeading = styled.h3`
  ${HeadingTxt}
  text-align: center;
  text-transform: uppercase;
`;

export const PrintButton = styled.button`
  background: #42abe9;
  border: none;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 8px;
  display: flex;
  cursor: pointer;
  transition: 0.2s;
  height: fit-content;

  &:hover {
    background: #1a95de;
  }
`;

export const ToolTipIconHover = ({ className, dataTip }) => (
  <svg
    data-tip={dataTip}
    className={className}
    width='17'
    height='17'
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.4 16.8C13.0392 16.8 16.8 13.0392 16.8 8.4C16.8 3.76081 13.0392 0 8.4 0C3.76081 0 0 3.76081 0 8.4C0 13.0392 3.76081 16.8 8.4 16.8ZM8.4 14.4C9.06274 14.4 9.6 13.8627 9.6 13.2C9.6 12.5373 9.06274 12 8.4 12C7.73726 12 7.2 12.5373 7.2 13.2C7.2 13.8627 7.73726 14.4 8.4 14.4ZM8.40732 10.8C8.92046 10.7959 9.33317 10.3733 9.32913 9.85602C9.32895 9.83306 9.41729 9.7824 9.53189 9.71668C9.59102 9.68277 9.65715 9.64485 9.72171 9.60466C9.75058 9.58669 9.77599 9.57091 9.79887 9.5567C9.85337 9.52286 9.89353 9.49793 9.93187 9.4735C10.9107 8.84981 11.4 8.06595 11.4 6.62404C11.4 4.94829 10.059 3.6 8.4 3.6C6.74315 3.6 5.4 4.95391 5.4 6.62404C5.4 7.14131 5.816 7.56064 6.32916 7.56064C6.84232 7.56064 7.25831 7.14131 7.25831 6.62404C7.25831 5.98845 7.76946 5.4732 8.4 5.4732C9.03374 5.4732 9.54169 5.98391 9.54169 6.62404C9.54169 7.37836 9.40933 7.59037 8.9389 7.89013C8.89518 7.91799 8.84827 7.94712 8.74527 8.01089L8.74195 8.01295C7.87654 8.55168 7.46258 8.80939 7.47087 9.87077C7.47491 10.388 7.89417 10.804 8.40732 10.8Z'
      fill='#C5C7D4'
    />
  </svg>
);

export const InfoIcon = ({ className }) => (
  <svg
    className={className}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.99996 1.66666C5.39996 1.66666 1.66663 5.39999 1.66663 9.99999C1.66663 14.6 5.39996 18.3333 9.99996 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99999C18.3333 5.39999 14.6 1.66666 9.99996 1.66666ZM9.99996 14.1667C9.54163 14.1667 9.16663 13.7917 9.16663 13.3333V9.99999C9.16663 9.54166 9.54163 9.16666 9.99996 9.16666C10.4583 9.16666 10.8333 9.54166 10.8333 9.99999V13.3333C10.8333 13.7917 10.4583 14.1667 9.99996 14.1667ZM10.8333 6.66666C10.8333 7.12689 10.4602 7.49999 9.99996 7.49999V7.49999C9.53972 7.49999 9.16663 7.12689 9.16663 6.66666V6.66666C9.16663 6.20642 9.53972 5.83332 9.99996 5.83332V5.83332C10.4602 5.83332 10.8333 6.20642 10.8333 6.66666V6.66666Z'
      fill='#42ABE9'
    />
  </svg>
);

export const CloseIcon = ({ className }) => (
  <svg
    className={className}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.0001 13.4142L5.41429 20C5.02376 20.3905 4.3906 20.3905 4.00008 20C3.60955 19.6095 3.60955 18.9763 4.00008 18.5858L10.5859 12L4.00007 5.41421C3.60955 5.02369 3.60955 4.39052 4.00008 4C4.3906 3.60947 5.02376 3.60947 5.41429 4L12.0001 10.5858L18.5859 4C18.9764 3.60947 19.6096 3.60947 20.0001 4C20.3906 4.39052 20.3906 5.02369 20.0001 5.41421L13.4143 12L20.0001 18.5858C20.3906 18.9763 20.3906 19.6095 20.0001 20C19.6096 20.3905 18.9764 20.3905 18.5859 20L12.0001 13.4142Z'
      fill='#242527'
    />
  </svg>
);

export const LinkIcon = ({ className }) => (
  <svg
    className={className}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V4C3.33333 3.63333 3.63333 3.33333 4 3.33333H7.33333C7.7 3.33333 8 3.03333 8 2.66667C8 2.3 7.7 2 7.33333 2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667ZM9.33333 2.66667C9.33333 3.03333 9.63333 3.33333 10 3.33333H11.7267L5.64 9.42C5.38 9.68 5.38 10.1 5.64 10.36C5.9 10.62 6.32 10.62 6.58 10.36L12.6667 4.27333V6C12.6667 6.36667 12.9667 6.66667 13.3333 6.66667C13.7 6.66667 14 6.36667 14 6V2H10C9.63333 2 9.33333 2.3 9.33333 2.66667Z'
      fill='#42ABE9'
    />
  </svg>
);

export const WarningIcon = ({ className }) => (
  <svg
    className={className}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.91236 18.0042H17.0876C18.5371 18.0042 19.4407 16.4323 18.7159 15.1804L11.6283 2.93475C10.9036 1.68288 9.09637 1.68288 8.37161 2.93475L1.28399 15.1804C0.55923 16.4323 1.46283 18.0042 2.91236 18.0042ZM9.99997 12.2487C9.48228 12.2487 9.05872 11.8252 9.05872 11.3075V7.75833C9.05872 7.24064 9.48228 6.81708 9.99997 6.81708C10.5177 6.81708 10.9412 7.24064 10.9412 7.75833V11.3075C10.9412 11.8252 10.5177 12.2487 9.99997 12.2487ZM10.9412 14.2392C10.9412 14.759 10.5198 15.1804 9.99997 15.1804C9.48013 15.1804 9.05872 14.759 9.05872 14.2392C9.05872 13.7193 9.48013 13.2979 9.99997 13.2979C10.5198 13.2979 10.9412 13.7193 10.9412 14.2392Z'
      fill='#DE2D68'
    />
  </svg>
);

export const TripleArrow = ({ className }) => (
  <svg
    className={className}
    width='324'
    height='35'
    viewBox='0 0 324 35'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.35437 35L5.79409 30.363L0.0584836 29.7026L2.35437 35ZM122.5 0C122.5 2.23495 120.981 4.20962 118.027 5.98012C115.083 7.74508 110.83 9.23147 105.639 10.5151C95.2635 13.0806 81.2997 14.7998 66.9574 16.3874C52.6323 17.9732 37.9335 19.4275 26.142 21.4657C20.2461 22.4848 15.0552 23.6534 10.9891 25.0651C6.94968 26.4676 3.91557 28.1438 2.45835 30.244L3.27996 30.814C4.54131 28.9961 7.30021 27.4044 11.3171 26.0098C15.3074 24.6244 20.4363 23.4668 26.3123 22.4511C38.0648 20.4196 52.7191 18.9697 67.0674 17.3814C81.3986 15.7949 95.4286 14.07 105.879 11.4859C111.1 10.1947 115.468 8.6799 118.541 6.83783C121.605 5.00133 123.5 2.76316 123.5 0H122.5Z'
      fill='#777B8B'
    />
    <path
      d='M180.93 35L177.926 30.0695L183.698 29.9333L180.93 35ZM157.5 0C157.5 4.89464 158.822 8.20726 160.806 10.6829C162.803 13.1753 165.501 14.8581 168.338 16.4418C173.952 19.5758 180.188 22.3188 181.319 30.4301L180.328 30.5682C179.279 23.0432 173.603 20.5264 167.85 17.3149C165.004 15.7258 162.154 13.9644 160.026 11.3083C157.883 8.63538 156.5 5.09521 156.5 0H157.5Z'
      fill='#777B8B'
    />
    <path
      d='M320.669 35L317.262 30.3393L323.002 29.7186L320.669 35ZM208.5 0C208.5 2.25141 209.927 4.22488 212.673 5.98764C215.417 7.74882 219.382 9.2334 224.226 10.5163C233.909 13.0805 246.943 14.7992 260.336 16.3869C273.711 17.9724 287.44 19.4267 298.455 21.4648C303.963 22.4839 308.815 23.6528 312.618 25.0656C316.397 26.4697 319.239 28.1493 320.604 30.2517L319.766 30.7963C318.588 28.9821 316.016 27.3951 312.27 26.003C308.546 24.6198 303.76 23.4632 298.273 22.4481C287.3 20.4177 273.618 18.9683 260.219 17.3799C246.837 15.7937 233.733 14.0683 223.97 11.483C219.092 10.1912 215.008 8.67475 212.133 6.82917C209.261 4.98517 207.5 2.74617 207.5 0H208.5Z'
      fill='#777B8B'
    />
  </svg>
);

export const TransparentBtn = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  outline: none;
  padding: 0;
`;

const PositionedCloseIcon = styled(CloseIcon)`
  position: absolute;
  right: 24px;
  top: 24px;
`;

export const InfoBtn = (props) => (
  <TransparentBtn type='button' {...props}>
    <InfoIcon />
  </TransparentBtn>
);

export const CloseBtn = ({ className, onClick }) => (
  <TransparentBtn type='button' className={className} onClick={onClick}>
    <PositionedCloseIcon />
  </TransparentBtn>
);
